import React from 'react';
import { getAnnualSavings, formatPlanPriceDisplay } from './billingPlanData';

/**
 * Shown on plan cards when annual billing is selected.
 * The interval toggle already states “2 months free”; this line is the dollar amount.
 */
export default function AnnualPlanPriceNote({ plan, billingInterval }) {
  if (billingInterval !== 'annual' || !plan) return null;

  const { saved } = getAnnualSavings(plan);

  return (
    <p className="pricing-annual-save">
      Save {formatPlanPriceDisplay(saved)} versus paying monthly
    </p>
  );
}
